var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"form-messages {{extraStyles}}\" ng-show=\"vm.errorMessages.length > 0\" ng-cloak>\n<img class=\"error-icon\" src=\"" + require("img/error-icon.png") + "\"/>\n<div class=\"messages-group\">\n<div class=\"error-messages\" ng-repeat=\"error in vm.errorMessages\">\n{{error.description}}\n</div>\n</div>\n</div>\n";
var id1="app/_directives/error-messages.directive.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;